import React, { useState } from 'react';
import {
  Layout, Card, Input, Button, Table, Space,
  Radio, Typography, Modal, message, Tag, Empty, Spin, Drawer, Select, Descriptions,
} from 'antd';
import { SearchOutlined, ReloadOutlined, SwapOutlined, PlusOutlined } from '@ant-design/icons';

const { Content } = Layout;
const { Title, Text } = Typography;

// TODO: 联调时替换为接口数据
const MOCK_PACKAGE_SERVICES = [
  { key: '1', packageName: '超高清录像 7天循环', packageId: 'PKG-7728-XA', totalDays: 365, usedDays: 165, expireDate: '2026-09-16', orderNo: 'test-order-001', sourceDID: 'test-DID-001', sourceLicense: 'test-LIC-001' },
  { key: '2', packageName: 'AI事件录像', packageId: 'PKG-1156-XB', totalDays: 30, usedDays: 15, expireDate: '2026-04-01', orderNo: 'test-order-002', sourceDID: 'test-DID-001', sourceLicense: 'test-LIC-001' },
  { key: '3', packageName: '全天录像 30天', packageId: 'PKG-0426-XC', totalDays: 90, usedDays: 30, expireDate: '2026-10-18', orderNo: 'test-order-003', sourceDID: 'test-DID-001', sourceLicense: 'test-LIC-001' },
  { key: '4', packageName: 'AI人脸识别包月', packageId: 'PKG-2233-AI', totalDays: 180, usedDays: 60, expireDate: '2026-11-01', orderNo: 'test-order-004', sourceDID: 'test-DID-002', sourceLicense: 'test-LIC-002' },
  { key: '5', packageName: '移动侦测 7天', packageId: 'PKG-5566-MD', totalDays: 30, usedDays: 22, expireDate: '2026-04-15', orderNo: 'test-order-005', sourceDID: 'test-DID-002', sourceLicense: 'test-LIC-002' },
  { key: '6', packageName: '云端存储 3个月', packageId: 'PKG-7788-CS', totalDays: 90, usedDays: 10, expireDate: '2026-09-30', orderNo: 'test-order-006', sourceDID: 'test-DID-003', sourceLicense: 'test-LIC-003' },
];

const MOCK_TRANSFER_RECORDS = [
  { key: '1', packageName: 'AI事件录像', packageId: 'PKG-1156-XB', totalDays: 30, usedDays: 15, expireDate: '2026-04-01', orderNo: 'test-order-002', sourceDID: 'test-DID-001', sourceLicense: 'test-LIC-001', sourceQueryType: 'did', targetDID: 'test-DID-009', targetLicense: 'test-LIC-009', targetQueryType: 'license', operator: 'admin', time: '2026-07-01 14:30:00', sourceEntName: '东莞康林物联网有限公司', sourceEntId: 'JGSf0Nd7', targetEntName: '东莞康林物联网有限公司', targetEntId: 'JGSf0Nd7' },
  { key: '2', packageName: '移动侦测 7天', packageId: 'PKG-5566-MD', totalDays: 30, usedDays: 22, expireDate: '2026-04-15', orderNo: 'test-order-005', sourceDID: 'test-DID-002', sourceLicense: 'test-LIC-002', sourceQueryType: 'license', targetDID: 'test-DID-010', targetLicense: 'test-LIC-010', targetQueryType: 'did', operator: 'platform_ops', time: '2026-07-02 09:15:00', sourceEntName: '捷顺科技股份有限公司', sourceEntId: 'A619355x', targetEntName: '东莞康林物联网有限公司', targetEntId: 'JGSf0Nd7' },
  { key: '3', packageName: '全天录像 30天', packageId: 'PKG-0426-XC', totalDays: 90, usedDays: 30, expireDate: '2026-10-18', orderNo: 'test-order-003', sourceDID: 'test-DID-001', sourceLicense: 'test-LIC-001', sourceQueryType: 'did', targetDID: 'test-DID-015', targetLicense: 'test-LIC-015', targetQueryType: 'did', operator: 'daishoutian', time: '2026-07-03 16:00:00', sourceEntName: '东莞康林物联网有限公司', sourceEntId: 'JGSf0Nd7', targetEntName: '东莞康林物联网有限公司', targetEntId: 'JGSf0Nd7' },
  { key: '4', packageName: '超高清录像 7天循环', packageId: 'PKG-7728-XA', totalDays: 365, usedDays: 165, expireDate: '2026-09-16', orderNo: 'test-order-001', sourceDID: 'test-DID-001', sourceLicense: 'test-LIC-001', sourceQueryType: 'license', targetDID: 'test-DID-020', targetLicense: 'test-LIC-020', targetQueryType: 'license', operator: 'admin', time: '2026-07-05 10:00:00', sourceEntName: '东莞康林物联网有限公司', sourceEntId: 'JGSf0Nd7', targetEntName: '捷顺科技股份有限公司', targetEntId: 'A619355x' },
];

const MOCK_ENTERPRISES = [
  { value: 'JGSf0Nd7', label: '东莞康林物联网有限公司' },
  { value: 'A619355x', label: '捷顺科技股份有限公司' },
];

const renderDeviceIds = (did, license, primaryType, tagLabel) => (
  <div style={{ fontSize: 12, lineHeight: '20px' }}>
    <div style={{ fontWeight: primaryType === 'did' ? 600 : 400, color: primaryType === 'did' ? '#262626' : '#8c8c8c' }}>
      DID: {did || '--'}{primaryType === 'did' && <Tag color="blue" style={{ marginLeft: 6, fontSize: 10, lineHeight: '16px', border: 'none' }}>{tagLabel}</Tag>}</div>
    <div style={{ fontWeight: primaryType === 'license' ? 600 : 400, color: primaryType === 'license' ? '#262626' : '#8c8c8c' }}>
      License: {license || '--'}{primaryType === 'license' && <Tag color="blue" style={{ marginLeft: 6, fontSize: 10, lineHeight: '16px', border: 'none' }}>{tagLabel}</Tag>}</div>
  </div>
);

const renderDuration = (record) => {
  const remaining = Math.max(0, record.totalDays - record.usedDays);
  return (
    <div style={{ fontSize: 12, lineHeight: '20px' }}>
      <div>已使用：<Text strong>{record.usedDays}天</Text></div>
      <div>剩余：<Text strong style={{ color: remaining <= 30 ? '#ff4d4f' : '#52c41a' }}>{remaining}天</Text></div>
      <div style={{ color: '#8c8c8c' }}>到期：{record.expireDate}</div>
    </div>
  );
};

const PackageTransfer = () => {
  const [role] = useState('platform');
  const [recordSearchScope, setRecordSearchScope] = useState('source');
  const [recordSearchType, setRecordSearchType] = useState('license');
  const [recordSearchId, setRecordSearchId] = useState('');
  const [recordLoading, setRecordLoading] = useState(false);
  const [transferRecords] = useState(MOCK_TRANSFER_RECORDS);
  const [filteredRecords, setFilteredRecords] = useState(MOCK_TRANSFER_RECORDS);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [queryIdType, setQueryIdType] = useState('license');
  const [queryId, setQueryId] = useState('');
  const [selectedEnt, setSelectedEnt] = useState(undefined);
  const [queryLoading, setQueryLoading] = useState(false);
  const [services, setServices] = useState([]);
  const [hasQueried, setHasQueried] = useState(false);
  const [deviceInfo, setDeviceInfo] = useState(null);
  const [selectedKey, setSelectedKey] = useState(undefined);
  const [targetIdType, setTargetIdType] = useState('license');
  const [targetId, setTargetId] = useState('');

  const handleRecordSearch = () => {
    setRecordLoading(true);
    setTimeout(() => {
      if (!recordSearchId.trim()) { setFilteredRecords(transferRecords); } else {
        const kw = recordSearchId.trim().toLowerCase();
        setFilteredRecords(transferRecords.filter(r =>
          (recordSearchScope === 'source' ? r.sourceDID + r.sourceLicense : r.targetDID + r.targetLicense).toLowerCase().includes(kw)));
      }
      setRecordLoading(false);
    }, 300);
  };

  const handleRecordReset = () => { setRecordSearchId(''); setFilteredRecords(transferRecords); };

  const handleDrawerQuery = () => {
    if (!queryId.trim()) { message.warning(`请输入 ${queryIdType === 'license' ? 'License' : '设备DID'}`); return; }
    setQueryLoading(true); setHasQueried(true);
    setTimeout(() => {
      const kw = queryId.trim().toLowerCase();
      if (kw.includes('test')) {
        let filtered = MOCK_PACKAGE_SERVICES;
        if (role === 'enterprise') filtered = MOCK_PACKAGE_SERVICES.filter((_, i) => i < 3);
        else if (selectedEnt) filtered = MOCK_PACKAGE_SERVICES.filter((_, i) => selectedEnt === 'JGSf0Nd7' ? i < 3 : i >= 3);
        setServices(filtered);
        setDeviceInfo({ did: filtered[0]?.sourceDID, license: filtered[0]?.sourceLicense, queryType: queryIdType });
      } else { setServices([]); setDeviceInfo(null); }
      setSelectedKey(undefined); setQueryLoading(false);
    }, 400);
  };

  const handleConfirm = () => {
    if (!selectedKey) { message.warning('请先选择一个套餐服务'); return; }
    if (!targetId.trim()) { message.warning('请输入目标设备标识'); return; }
    if (!targetId.trim().toLowerCase().includes('test')) { message.error('目标设备不存在，请重新输入'); return; }
    const service = services.find(s => s.key === selectedKey);
    Modal.confirm({
      title: '确认转移',
      content: `确认将套餐「${service.packageName}」转移到设备 [${targetId}]？转移后源设备套餐将关闭。此操作不可撤销。`,
      onOk: () => { setSelectedKey(undefined); setTargetId(''); message.success('套餐转移成功'); setDrawerOpen(false); },
    });
  };

  const openDrawer = () => {
    setQueryId(''); setServices([]); setHasQueried(false); setDeviceInfo(null); setSelectedKey(undefined); setTargetId(''); setDrawerOpen(true);
  };

  const serviceColumns = [
    { title: '', width: 50, render: (_, r) => <Radio checked={selectedKey === r.key} onChange={() => setSelectedKey(r.key)} /> },
    { title: '订单号', dataIndex: 'orderNo', key: 'orderNo', width: 180 },
    { title: '套餐服务', key: 'pkgInfo', width: 200, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.packageName}</div><div style={{ fontSize: 12, color: '#8c8c8c' }}>ID: {r.packageId}</div></div>) },
    { title: '已使用时长', dataIndex: 'usedDays', key: 'usedDays', width: 100, render: d => `${d}天` },
    { title: '到期时间', dataIndex: 'expireDate', key: 'expireDate', width: 120 },
  ];

  const recordColumns = [
    { title: '套餐服务', key: 'pkgInfo', width: 200, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.packageName}</div><div style={{ fontSize: 12, color: '#8c8c8c' }}>ID: {r.packageId}</div></div>) },
    { title: '服务时长', key: 'duration', width: 130, render: (_, r) => renderDuration(r) },
    { title: '原设备', key: 'sourceDevice', width: 170, render: (_, r) => renderDeviceIds(r.sourceDID, r.sourceLicense, r.sourceQueryType, '查询') },
    { title: '关联订单号', dataIndex: 'orderNo', key: 'orderNo', width: 170 },
    { title: '目标设备', key: 'targetDevice', width: 170, render: (_, r) => renderDeviceIds(r.targetDID, r.targetLicense, r.targetQueryType, '输入') },
    { title: '操作人', dataIndex: 'operator', key: 'operator', width: 90 },
    { title: '操作时间', dataIndex: 'time', key: 'time', width: 170 },
    ...(role === 'platform' ? [
      { title: '原设备企业', key: 'sourceEnt', width: 170, render: (_, r) => (<div><div>{r.sourceEntName}</div><div style={{ fontSize: 12, color: '#8c8c8c' }}>{r.sourceEntId}</div></div>) },
      { title: '目标设备企业', key: 'targetEnt', width: 170, render: (_, r) => (<div><div>{r.targetEntName}</div><div style={{ fontSize: 12, color: '#8c8c8c' }}>{r.targetEntId}</div></div>) },
    ] : []),
  ];

  return (
    <Layout style={{ padding: '20px', background: '#fff' }}>
      <Content>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <Title level={4} style={{ margin: 0 }}>套餐转移</Title>
          <Button type="primary" icon={<PlusOutlined />} onClick={openDrawer}>发起转移</Button>
        </div>
        <Card bordered={false} style={{ marginBottom: 16, borderRadius: 8, background: '#fafafa' }}>
          <Space wrap>
            <Select value={recordSearchScope} onChange={setRecordSearchScope} style={{ width: 100 }} options={[{ value: 'source', label: '原设备' }, { value: 'target', label: '目标设备' }]} />
            <Radio.Group value={recordSearchType} onChange={e => setRecordSearchType(e.target.value)} optionType="button" buttonStyle="solid">
              <Radio.Button value="license">License</Radio.Button><Radio.Button value="did">设备DID</Radio.Button>
            </Radio.Group>
            <Input placeholder={`输入${recordSearchType.toUpperCase()}搜索...`} value={recordSearchId} onChange={e => setRecordSearchId(e.target.value)} style={{ width: 260 }} allowClear onPressEnter={handleRecordSearch} />
            <Button type="primary" icon={<SearchOutlined />} onClick={handleRecordSearch} loading={recordLoading}>查询</Button>
            <Button icon={<ReloadOutlined />} onClick={handleRecordReset}>重置</Button>
          </Space>
        </Card>
        <Card title={<Space><SwapOutlined style={{ color: '#1890ff' }} /><span>转移记录</span></Space>} bordered={false} style={{ borderRadius: 8 }}>
          <Table columns={recordColumns} dataSource={filteredRecords} rowKey="key" size="small" loading={recordLoading}
            scroll={{ x: role === 'platform' ? 1500 : 1200 }} pagination={{ showSizeChanger: true, showTotal: t => `共 ${t} 条记录` }}
            locale={{ emptyText: <Empty description="暂无转移记录" /> }} />
        </Card>
        <Drawer title={<Space><SwapOutlined style={{ color: '#1890ff' }} /><span>发起转移</span></Space>} width={960} open={drawerOpen} onClose={() => setDrawerOpen(false)} destroyOnClose
          footer={<div style={{ textAlign: 'right' }}><Button onClick={() => setDrawerOpen(false)}>取消</Button><Button type="primary" icon={<SwapOutlined />} onClick={handleConfirm} disabled={!selectedKey || !targetId.trim()} style={{ marginLeft: 8 }}>确认转移</Button></div>}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div style={{ padding: '16px', background: '#fafafa', borderRadius: 8, border: '1px solid #f0f0f0' }}>
              <Space wrap>
                {role === 'platform' && <Select placeholder="选择企业" value={selectedEnt} onChange={setSelectedEnt} allowClear style={{ width: 200 }} options={MOCK_ENTERPRISES} />}
                <Radio.Group value={queryIdType} onChange={e => setQueryIdType(e.target.value)} optionType="button" buttonStyle="solid">
                  <Radio.Button value="license">License</Radio.Button><Radio.Button value="did">设备DID</Radio.Button>
                </Radio.Group>
                <Input placeholder={`请输入${queryIdType.toUpperCase()}...`} value={queryId} onChange={e => setQueryId(e.target.value)} style={{ width: 280 }} allowClear onPressEnter={handleDrawerQuery} />
                <Button type="primary" icon={<SearchOutlined />} onClick={handleDrawerQuery} loading={queryLoading}>查询</Button>
              </Space>
            </div>
            {queryLoading && <div style={{ textAlign: 'center', padding: 40 }}><Spin tip="查询中..." /></div>}
            {!queryLoading && hasQueried && services.length > 0 && (<>
              {deviceInfo && <Descriptions bordered size="small" column={2} title="设备信息">
                <Descriptions.Item label="DID"><Text strong={deviceInfo.queryType === 'did'}>{deviceInfo.did || '--'}</Text>{deviceInfo.queryType === 'did' && <Tag color="blue" style={{ marginLeft: 8, border: 'none' }}>当前查询</Tag>}</Descriptions.Item>
                <Descriptions.Item label="License"><Text strong={deviceInfo.queryType === 'license'}>{deviceInfo.license || '--'}</Text>{deviceInfo.queryType === 'license' && <Tag color="blue" style={{ marginLeft: 8, border: 'none' }}>当前查询</Tag>}</Descriptions.Item>
              </Descriptions>}
              <Table columns={serviceColumns} dataSource={services} rowKey="key" size="small" pagination={false}
                onRow={r => ({ onClick: () => setSelectedKey(r.key), style: { cursor: 'pointer', background: selectedKey === r.key ? '#e6f4ff' : undefined } })} />
              <div style={{ padding: '16px', background: '#fafafa', borderRadius: 8, border: '1px solid #f0f0f0' }}>
                <Space wrap size="middle">
                  <Text strong>转移至设备：</Text>
                  <Radio.Group value={targetIdType} onChange={e => setTargetIdType(e.target.value)} optionType="button" buttonStyle="solid">
                    <Radio.Button value="license">License</Radio.Button><Radio.Button value="did">设备DID</Radio.Button>
                  </Radio.Group>
                  <Input placeholder={`请输入目标${targetIdType.toUpperCase()}...`} value={targetId} onChange={e => setTargetId(e.target.value)} style={{ width: 260 }} allowClear onPressEnter={handleConfirm} />
                </Space>
                <Text type="secondary" style={{ display: 'block', marginTop: 8, fontSize: 12 }}>提示：输入 `test` 开头的标识可验证转移流程</Text>
              </div>
            </>)}
            {!queryLoading && hasQueried && services.length === 0 && <Empty description="未查询到相关套餐服务" style={{ padding: 40 }} />}
          </div>
        </Drawer>
      </Content>
    </Layout>
  );
};

export default PackageTransfer;
